import { Brand } from "@/types/entities";
import { log } from "@/utils/logger";
import { useQuery } from "@tanstack/react-query";
import { useUser } from "@/context/user";
import storage from "@/utils/storage";
import { isDefined } from "@/utils/validations";
import api from "@/config/api";

const useQueryBrands = () => {
    const authenticated = useUser(state => state.authenticated);
    const oid = storage.getItem("oid");
    const enabled = authenticated && isDefined(oid);

    const getBrands = async () => {
        try {
            const data = await api.get<Brand[]>(`/organizations/${oid}/brands`);
            return data;
        } catch (e) {
            log.error(e, "getBrands");
        }
    };

    return useQuery({ queryKey: ["brands", oid], queryFn: getBrands, enabled });
};

export default useQueryBrands;
